<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <el-input v-model="activityName" placeholder="姓名"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-input v-model="account" placeholder="账号"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-select v-model="userType" placeholder="请选择用户状态">
                                <el-option label="启用" value="ENABLE"></el-option>
                                <el-option label="停用" value="DISABLE"></el-option>
                            </el-select>
                        </div>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>新增
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <!--<el-table-column
                                prop="nickName"
                                label="用户昵称"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip>
                            </el-table-column>-->
                            <el-table-column
                                prop="name"
                                label="姓名"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="gender"
                                align="center"
                                header-align="center"
                                label="性别">
                                <template slot-scope="scope">
                                    {{ scope.row.gender==='FEMALE'?'女':scope.row.gender==='MALE'?'男':'秘密' }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="tel"
                                align="center"
                                header-align="center"
                                label="账号">
                            </el-table-column>
                            <el-table-column
                                prop="survival"
                                align="center"
                                header-align="center"
                                label="用户状态">
                                <template slot-scope="scope">
                                    {{ scope.row.survival1==='ENABLE'?'启用':'停用' }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="createdDate"
                                align="center"
                                header-align="center"
                                label="录入时间">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.survival1==='ENABLE'" @click="stopJudgeInfo(scope.row.judgeUuid)">停用</el-button>
                                    <el-button type="text" size="small" v-else @click="startJudgeInfo(scope.row.judgeUuid)">启用</el-button>
                                    <el-button type="text" size="small" @click="removeJudgeLibrary(scope.row.judgeUuid)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--编辑/新增-->
        <management-dialog ref="activityManagementDialogRef" @submit="successList"></management-dialog>

    </div>
</template>

<script>
    import { findJudgeList, stopJudgeInfo, startJudgeInfo, removeJudgeLibrary } from '../../utils/interface';
    import managementDialog from './managementDialog'
    export default {
        components: {managementDialog},
        data() {
            return {
                activityName: '',
                account: '',
                userType: '',
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
        },
        methods: {
            getList(){
                let params = {
                    name:this.activityName,
                    type:"LEADER",
                    tel:this.account,
                    survival:this.userType,
                    current:this.current,
                    pageSize:this.pageSize,
                }
                findJudgeList(params).then((res)=>{
                    this.total = res.total;
                    this.tableData = res.list;
                });
            },
            resetData(){
                this.activityName = '';
                this.account = '';
                this.userType = '';
                this.getList();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },
            successList(){
                this.current = 1;
                this.getList();
            },
            // 新增
            toDialog(type){
                this.$refs.activityManagementDialogRef.init(type,'LEADER')
            },
            // 启用
            startJudgeInfo(uuid){
                this.$confirm('确定要启用当前用户嘛？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    startJudgeInfo({uuid:uuid}).then((res)=>{
                        if(res.success){
                            this.$message.success("启用成功");
                            this.getList();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                });
            },
            // 停用
            stopJudgeInfo(uuid){
                this.$confirm('确定要停用当前用户嘛？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    stopJudgeInfo({uuid:uuid}).then((res)=>{
                        if(res.success){
                            this.$message.success("停用成功");
                            this.getList();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                });
            },
            removeJudgeLibrary(uuid){
                this.$confirm('确定要删除当前用户嘛？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    removeJudgeLibrary(uuid).then((res)=>{
                        if(res.success){
                            this.$message.success("删除成功");
                            this.getList();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                    .searchItem {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        // margin-right: 30px;

                        .name {
                            padding-right: 20px;
                            min-width: 100px;
                        }
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/leadershipLibraryList.vue